export default theme => ({

  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    opacity: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: 'opacity 0.5s ease-in-out',
    marginTop: theme.spacing.unit * 7
  },

  ready: {
    opacity: 1
  },

  paper: {
    minHeight: '100%'
  },

  '@media (min-width: 600px)': {

    root: {
      marginTop: theme.spacing.unit * 8
    }

  }

})



// WEBPACK FOOTER //
// ./src/styles/components/App.js